import { Box, Tooltip } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { ViewErrorKind } from '../../utils/async-view/view-error-kind';
import { viewErrorPresentation } from './view-error-presentation';

interface InlineViewErrorProps {
  kind: ViewErrorKind;
  /** Raw error message, exposed through the tooltip instead of the visible label. */
  detail?: string;
}

/**
 * Compact one-line error used where a full centered state would break the layout
 * (labels, chips, table cells, modal sections).
 */
export function InlineViewError({ kind, detail }: InlineViewErrorProps) {
  const { icon: Icon, title } = viewErrorPresentation[kind];

  const label = (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        verticalAlign: 'middle',
        gap: 0.5,
        typography: 'body2',
        color: 'text.secondary',
      }}
    >
      <Icon fontSize="small" color="disabled" />
      <FormattedMessage {...title} />
    </Box>
  );

  return detail ? <Tooltip title={detail}>{label}</Tooltip> : label;
}
